export enum MaintEventStatus {
  Complete = 0,
  InProgress = 1,
  Scheduled = 2,
  OnHold = 3,
  Cancelled = 10
}

export const MaintEventStatusMapping: Record<MaintEventStatus, string> = {
  [MaintEventStatus.Complete]: 'Complete',
  [MaintEventStatus.InProgress]: 'In Progress',
  [MaintEventStatus.Scheduled]: 'Scheduled',
  [MaintEventStatus.OnHold]: 'On Hold',
  [MaintEventStatus.Cancelled]: 'Cancelled'
};
